module.exports = __webpack_public_path__ + "img/kh.f0868f14.svg";